import { useTableSettingsStore } from 'bpm/components/SpecTable/settings/store'
import LoadingBackdrop from 'bpm/components/loadingBackdrop/LoadingBackdrop'
import React, { FC } from 'react'
import { useListingPageStore } from '../store'

const ProductListingLoading: FC = () => {
    const isLoading = useListingPageStore((state) => state.isLoading)
    const isSettingsLoading = useTableSettingsStore(
        (state) => state.isTableSettingsLoaded
    )
    return <LoadingBackdrop isVisible={!!isLoading || !!isSettingsLoading} />
}

export default ProductListingLoading
